<a class="ia-card" [routerLink]="routerCommands | localeLink">
  <!-- House band: the auction house's own colour, its logo on a white plaque. -->
  <div
    class="ia-card__band"
    [style.background]="brandColor"
    [style.color]="brandContrast"
  >
    <span class="ia-card__plaque" [class.is-bare]="logoOnBrand">
      @if (sale.house.logo_url) {
        <img
          class="ia-card__logo"
          [src]="sale.house.logo_url"
          [alt]="houseName"
          loading="lazy"
          decoding="async"
        />
      } @else {
        <span class="ia-card__wordmark">{{ houseName }}</span>
      }
    </span>
    @if (countryLabel) {
      <span class="ia-card__country">{{ countryLabel }}</span>
    }
  </div>

  <!-- Image area. Most sales publish no cover, so the placeholder is the
       normal state, not an error state. -->
  <div class="ia-card__media">
    @if (hasCoverImage) {
      <img
        class="ia-card__image"
        [src]="sale.cover_image_url"
        alt=""
        loading="lazy"
        decoding="async"
      />
    } @else {
      <span class="ia-card__placeholder" [style.--ia-brand]="brandColor">
        <span class="ia-card__monogram" aria-hidden="true">{{ monogram }}</span>
      </span>
    }

    <span class="ia-card__chip">
      <app-international-status-chip
        [status]="sale.status"
        [brandColor]="brandColor"
      ></app-international-status-chip>
    </span>
  </div>

  <div class="ia-card__body">
    <h3 class="ia-card__title">{{ saleName }}</h3>

    <p class="ia-card__meta">
      @if (formatDateRange) {
        <span class="ia-card__dates">{{ formatDateRange }}</span>
      }
      @if (formatDateRange && lotCountLabel) {
        <span class="ia-card__sep" aria-hidden="true">·</span>
      }
      @if (lotCountLabel) {
        <span class="ia-card__lots">{{ lotCountLabel }}</span>
        <span>{{ 'international_auctions.card.lots' | translate }}</span>
      }
    </p>

    <span class="ia-card__footer">
      <span class="ia-card__where">{{ footerMeta }}</span>
      <span class="ia-card__cta">
        <span>{{ ctaKey | translate }}</span>
        <span class="ia-card__arrow" aria-hidden="true">&#8594;</span>
      </span>
    </span>
  </div>
</a>
